export default "__VITE_ASSET__D4dckD6t__"